import { useEffect, useState } from "react";
import { Coins, Trophy } from "lucide-react";
import { StoreFlow } from "./store/StoreFlow";
import { TimeBankCard } from "./TimeBankCard";
import { api, C, fmtChips } from "../lib/api";

// Your money, at the top of the menu: chips and the store, time bank cards, gold and VIP.
// Anything that moves a balance can shout `pfp-balances` and this picks it up.
export const WalletSection = () => {
  const [balances, setBalances] = useState(null);
  const [store, setStore] = useState(false);
  useEffect(() => {
    const load = () => api.get(C.ApiRoutes.WALLET_BALANCES).then((r) => setBalances(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 15000);
    window.addEventListener("pfp-balances", load);
    return () => { clearInterval(id); window.removeEventListener("pfp-balances", load); };
  }, []);
  return (
    <section data-testid="drawer-wallet" className="flex flex-col gap-3">
      <div className="gold-card rounded-2xl p-5">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] gold-text"><Coins className="w-4 h-4" /> Chips</div>
        <div data-testid="chips-balance" className="font-mono text-3xl mt-2 text-amber-100">{balances ? fmtChips(balances.CHIPS) : "—"}</div>
        <p className="text-[11px] text-slate-400 mt-1">Play money. Never cash-redeemable.</p>
        <div data-testid="timebank-balance" className="mt-3 flex items-center gap-2 text-sm text-cyan-200" title={`Time bank cards in your account (max ${C.TDA.TIMEBANK_MAX_ACCOUNT})`}>
          <TimeBankCard h={16} /><span className="font-mono">{balances ? balances.TIMEBANK || 0 : "—"}<span className="text-slate-500 text-xs"> / {C.TDA.TIMEBANK_MAX_ACCOUNT}</span></span>
          <span className="text-[11px] text-slate-400">time bank cards</span>
        </div>
        <button data-testid="buy-chips" onClick={() => setStore(true)} className="mt-4 btn-gold rounded-full px-5 py-2 text-xs font-display tracking-[0.2em] btn-lift">STORE</button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="gold-card rounded-2xl p-4">
          <div className="text-[11px] uppercase tracking-[0.25em] gold-text">Gold</div>
          <div data-testid="gold-balance" className="font-mono text-2xl mt-1">{balances ? balances.GOLD : "—"}</div>
        </div>
        <div className="gold-card rounded-2xl p-4">
          <div className="flex items-center gap-1 text-[11px] uppercase tracking-[0.25em] gold-text"><Trophy className="w-3 h-3" /> VIP</div>
          <div data-testid="vip-balance" className="font-mono text-2xl mt-1">{balances ? balances.VIP : "—"}</div>
          <div className="text-[10px] text-slate-500 mt-1 leading-tight">Earned on games played, purchases and streaks</div>
        </div>
      </div>
      {store && <StoreFlow origin="lobby" after="stay" onClose={() => setStore(false)}
        onPurchased={() => window.dispatchEvent(new Event("pfp-balances"))} />}
    </section>
  );
};
